// ChartViewToggle — picks how the hero renders the balance trend: line (default) or
// composition (stacked area). Ported from the design's stacked-sparkline.jsx
// ChartViewToggle (FM-2116).
//
// Two of the original four views were removed from the hero: passbook (segmented bars per
// period) and individual cumulative lines, the latter offered only where the payload set
// `layers.stackedLine`. Their charts — `StackedBarChart` and `StackedLineChart` — are still
// exported from charts/StackedTrendCharts.jsx if either view is ever wanted back; nothing
// selects them now.
//
// NOT lazy-loaded with the charts: the toggle is what triggers loading them, so it has
// to exist first. Icon-only buttons carry aria-labels (FRONTEND_RULES §12).
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { cx } from '../../../utils/cx';
import './stacked-trend.css';

const ICONS = {
  line: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="1,12 4,8 7,10 10,4 15,6" />
    </svg>
  ),
  composition: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1,14 L1,10 Q5,8 9,7 T15,4 L15,14 Z" fill="currentColor" opacity="0.15" stroke="none" />
      <path d="M1,14 L1,12 Q5,11 9,10 T15,8 L15,14 Z" fill="currentColor" opacity="0.25" stroke="none" />
      <path d="M1,10 Q5,8 9,7 T15,4" />
    </svg>
  ),
};

const VIEWS = ['line', 'composition'];

export function ChartViewToggle({ mode, onChange }) {
  const { t } = useTranslation();
  return (
    <div className="chart-view-toggle" role="radiogroup" aria-label={t('reusable.chartViewToggle.aria')}>
      {VIEWS.map((view) => (
        <button
          key={view}
          type="button"
          className={cx('cvt-btn', mode === view && 'is-active')}
          onClick={() => onChange(view)}
          aria-label={t(`reusable.chartViewToggle.${view}`)}
          title={t(`reusable.chartViewToggle.${view}`)}
          aria-pressed={mode === view}
        >
          {ICONS[view]}
        </button>
      ))}
    </div>
  );
}

ChartViewToggle.propTypes = {
  mode: PropTypes.oneOf(VIEWS).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ChartViewToggle;
